import { GET_CART_ITEMS } from '../actionTypes/CartActionTypes';

export default function CartItemsReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_CART_ITEMS:
            return action.payload;
        default:
            return state;
    }
}
